import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, BellRingIcon, CheckIcon, ClockIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Avatar } from '../../components/ui/Avatar';
import { formatDateTime, fullName, priorityClass, priorityLabel, voiceLabel } from '../../utils/labels';
export function AdminAnnouncementReads() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    announcements,
    members,
    pushToast
  } = useApp();
  const [pogled, setPogled] = useState<'vsi' | 'prebrali' | 'niso'>('niso');
  const a = announcements.find(x => x.id === id);
  if (!a) {
    return <Card className="p-10 text-center" data-id="element-516" data-mp="ziakfgzsxzu9">
        <p className="text-sm font-medium text-ink" data-id="element-517" data-mp="vg6z80nbzgvs">Obvestilo ne obstaja.</p>
        <Link to="/admin/obvestila" className="mt-2 inline-block text-[13px] font-medium text-green-600" data-id="element-518" data-mp="vi9ylbadimd6">
          Nazaj
        </Link>
      </Card>;
  }
  const prejemniki = members.filter(m => a.prejemniki.includes(m.id));
  const delez = Math.round(a.prebrali.length / Math.max(a.prejemniki.length, 1) * 100);
  const prikazani = prejemniki.filter(m => {
    const prebral = a.prebrali.includes(m.id);
    return pogled === 'vsi' ? true : pogled === 'prebrali' ? prebral : !prebral;
  });
  return <div className="mx-auto max-w-4xl space-y-4" data-id="element-519" data-mp="qa5a9lupameb">
      <button onClick={() => navigate('/admin/obvestila')} className="inline-flex items-center gap-1.5 text-[13px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-520" data-mp="u8cqmfl95loz">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-521" data-mp="146sl8sjhnd38" />
        Nazaj na obvestila
      </button>

      <Card className="p-5" data-id="element-522" data-mp="311exzvwdmyxi">
        <Badge className={priorityClass[a.prioriteta]} data-id="element-523" data-mp="3126ud8xst0ou">{priorityLabel[a.prioriteta]}</Badge>
        <h1 className="mt-2.5 text-xl font-semibold text-ink" data-id="element-524" data-mp="3611cs9rusn8f">{a.naslov}</h1>
        <p className="mt-1 text-[13px] text-ink-muted" data-id="element-525" data-mp="2xyr9d6qo7ytz">
          {a.avtor} · {formatDateTime(a.objavljeno)} · {a.obcinstvoLabel}
        </p>
        <p className="mt-4 whitespace-pre-line border-t border-line pt-4 text-sm leading-relaxed text-ink" data-id="element-526" data-mp="37wf6u4fnvkfu">
          {a.besedilo}
        </p>
      </Card>

      <div className="grid gap-3 sm:grid-cols-3" data-id="element-527" data-mp="32vr4wnpw9j6u">
        <Card className="p-4" data-id="element-528" data-mp="3gwv8d8cughi2">
          <p className="text-2xl font-semibold text-ink" data-id="element-529" data-mp="3gw1y3xeof9v6">{delez} %</p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-530" data-mp="3cvrugrecwvjh">Branost</p>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-canvas" data-id="element-531" data-mp="3ctf9e5day527">
            <div className="h-full rounded-full bg-purple-500" style={{
            width: `${delez}%`
          }} data-id="element-532" data-mp="3qmemy1tixp74" />
          </div>
        </Card>
        <Card className="p-4" data-id="element-533" data-mp="3lq65ghrutjws">
          <p className="text-2xl font-semibold text-green-600" data-id="element-534" data-mp="4f6n1f1diaih">{a.prebrali.length}</p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-535" data-mp="3vm9iiio8v2yi">Prebralo</p>
        </Card>
        <Card className="p-4" data-id="element-536" data-mp="j2f775cntq6l">
          <p className="text-2xl font-semibold text-amber-600" data-id="element-537" data-mp="j25gtgnpdh0d">
            {a.prejemniki.length - a.prebrali.length}
          </p>
          <p className="mt-0.5 text-[13px] text-ink-muted" data-id="element-538" data-mp="n3gxuxsigtwy">Še ni prebralo</p>
        </Card>
      </div>

      <Card className="overflow-hidden" data-id="element-539" data-mp="93ze4wu2o6ug">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line px-5 py-3" data-id="element-540" data-mp="e32a7rs2r2qa">
          <div className="flex gap-1.5" data-id="element-541" data-mp="3vjadzbixk3dh">
            {([['niso', 'Ni prebralo'], ['prebrali', 'Prebralo'], ['vsi', 'Vsi prejemniki']] as const).map(([k, label]) => <button key={k} onClick={() => setPogled(k)} aria-pressed={pogled === k} className={`rounded-lg border px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out ${pogled === k ? 'border-green-500 bg-green-500 text-white' : 'border-line bg-white text-ink-muted hover:bg-canvas'}`} data-id="element-542" data-mp="3mh15er782k2q">
                {label}
              </button>)}
          </div>
          <Button variant="secondary" size="sm" onClick={() => pushToast('Opomnik je bil poslan članom, ki obvestila še niso prebrali.')} data-id="element-543" data-mp="eyzcxvdxw7yn">
            <BellRingIcon className="h-4 w-4" data-id="element-544" data-mp="51beaud7qgb7" />
            Pošlji opomnik
          </Button>
        </div>

        <ul className="divide-y divide-line" data-id="element-545" data-mp="zggw0yekn2p">
          {prikazani.map(m => {
          const prebral = a.prebrali.includes(m.id);
          return <li key={m.id} className="flex items-center gap-3 px-5 py-3" data-id="element-546" data-mp="3s8dllln6nj6z">
                <Avatar member={m} size="sm" data-id="element-547" data-mp="3n8r615jvtqv0" />
                <span className="min-w-0 flex-1" data-id="element-548" data-mp="1qenycibjoyxc">
                  <span className="block truncate text-sm font-medium text-ink" data-id="element-549" data-mp="1qeeap1dz33ut">{fullName(m)}</span>
                  <span className="block text-[12px] text-ink-muted" data-id="element-550" data-mp="1lgcpoawzkugp">{voiceLabel[m.voice]}</span>
                </span>
                {prebral ? <Badge className="bg-green-50 text-green-700 border-green-200" data-id="element-551" data-mp="1xy5k82c9i0x2">
                    <CheckIcon className="h-3 w-3" data-id="element-552" data-mp="22p5ipc114r1o" />
                    Prebrano
                  </Badge> : <Badge className="bg-amber-50 text-amber-800 border-amber-200" data-id="element-553" data-mp="27oi4dtg5zs2o">
                    <ClockIcon className="h-3 w-3" data-id="element-554" data-mp="1a0q76zh3wqv3" />
                    Čaka
                  </Badge>}
              </li>;
        })}
          {prikazani.length === 0 && <li className="px-5 py-10 text-center text-sm text-ink-muted" data-id="element-555" data-mp="1jy4muwv7hbmc">Ni članov v tem pogledu.</li>}
        </ul>
      </Card>
    </div>;
}